import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faAdjust,
    faAngleDoubleDown,
    faAngleDown,
    faArchive,
    faArrowRight,
    faArrowUpRightFromSquare,
    faBalanceScale,
    faBan,
    faBars,
    faBell,
    faBorderStyle,
    faBox,
    faBoxesStacked,
    faBuilding,
    faBuildingCircleExclamation,
    faBuildingLock,
    faBuildingUser,
    faCalculator,
    faCalendarCheck,
    faCalendarDays,
    faCalendarPlus,
    faCalendarWeek,
    faCartArrowDown,
    faCartShopping,
    faCashRegister,
    faChalkboardUser,
    faChartLine,
    faCheck,
    faCheckToSlot,
    faCircleCheck,
    faCircleChevronLeft,
    faCircleChevronRight,
    faCircleInfo,
    faCircleMinus,
    faCity,
    faClipboardCheck,
    faClipboardList,
    faClipboardUser,
    faClock,
    faClockRotateLeft,
    faClone,
    faCode,
    faCogs,
    faCopy,
    faDollarSign,
    faDoorClosed,
    faDoorOpen,
    faDownload,
    faDumpster,
    faExchangeAlt,
    faEye,
    faFerry,
    faFile,
    faFileArrowUp,
    faFileCircleCheck,
    faFileCirclePlus,
    faFileCode,
    faFileContract,
    faFileDownload,
    faFileExcel,
    faFileImport,
    faFileInvoice,
    faFileInvoiceDollar,
    faFileLines,
    faFilePdf,
    faFilePrescription,
    faFileSignature,
    faFileWord,
    faFilter,
    faFlag,
    faFloppyDisk,
    faFolder,
    faGears,
    faGrip,
    faGripVertical,
    faHandHoldingDollar,
    faHandPointer,
    faHandshake,
    faHourglassEnd,
    faHourglassHalf,
    faHourglassStart,
    faHouse,
    faHouseLock,
    faHouseMedical,
    faIndustry,
    faInfo,
    faInfoCircle,
    faLaptopCode,
    faLink,
    faLinkSlash,
    faList,
    faListCheck,
    faMagnifyingGlass,
    faMoneyBillTrendUp,
    faMoneyCheckAlt,
    faMoneyCheckDollar,
    faMoon,
    faPallet,
    faPause,
    faPen,
    faPencil,
    faPeopleRoof,
    faPersonWalkingDashedLineArrowRight,
    faPiggyBank,
    faPlane,
    faPlay,
    faPlus,
    faPlusSquare,
    faPrint,
    faQrcode,
    faRectangleAd,
    faReply,
    faRestroom,
    faRotateRight,
    faSchool,
    faShare,
    faShip,
    faShirt,
    faShop,
    faShrimp,
    faShuffle,
    faSignature,
    faSitemap,
    faSquare,
    faStar,
    faStop,
    faSun,
    faTable,
    faTemperatureHalf,
    faTicket,
    faTimeline,
    faToggleOff,
    faToggleOn,
    faToolbox,
    faTools,
    faTrash,
    faTriangleExclamation,
    faTruck,
    faTruckLoading,
    faTruckPlane,
    faTv,
    faUniversity,
    faUser,
    faUserLock,
    faUserPen,
    faUserPlus,
    faUserShield,
    faUserTie,
    faUtensils,
    faWarehouse,
    faXmark,
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faShip,
    faUniversity,
    faExchangeAlt,
    faFilePrescription,
    faFileContract,
    faDumpster,
    faIndustry,
    faTruckLoading,
    faArchive,
    faTemperatureHalf,
    faCheckToSlot,
    faFileInvoiceDollar,
    faUserTie,
    faAdjust,
    faSun,
    faMoon,
    faBorderStyle,
    faFlag,
    faMoneyCheckAlt,
    faFileExcel,
    faFilePdf,
    faCogs,
    faTools,
    faFileDownload,
    faCalculator,
    faPlusSquare,
    faLaptopCode,
    faPallet,
    faPause,
    faBalanceScale,
    faAngleDoubleDown,
    faAngleDown,
    faDollarSign,
    faSitemap,
    faStop,
    faFileWord,
    faInfo,
    faClipboardList,
    faFileCircleCheck,
    faFolder,
    faGears,
    faChartLine,
    faPeopleRoof,
    faBuildingUser,
    faBuilding,
    faWarehouse,
    faCity,
    faMoneyBillTrendUp,
    faMagnifyingGlass,
    faUserPlus,
    faCircleCheck,
    faPersonWalkingDashedLineArrowRight,
    faBuildingCircleExclamation,
    faUser,
    faEye,
    faQrcode,
    faUserLock,
    faBuildingLock,
    faUserPen,
    faDoorOpen,
    faHourglassHalf,
    faDoorClosed,
    faRotateRight,
    faCircleInfo,
    faCircleMinus,
    faHandHoldingDollar,
    faCheck,
    faHouseMedical,
    faHandshake,
    faRestroom,
    faShirt,
    faClipboardUser,
    faClipboardCheck,
    faShare,
    faReply,
    faBell,
    faTv,
    faSignature,
    faFileSignature,
    faFileArrowUp,
    faFerry,
    faTruck,
    faPlane,
    faPlay,
    faPiggyBank,
    faCartShopping,
    faCartArrowDown,
    faInfoCircle,
    faShrimp,
    faHouse,
    faHouseLock,
    faCalendarDays,
    faBars,
    faUserShield,
    faCalendarWeek,
    faPlus,
    faGrip,
    faGripVertical,
    faCircleChevronLeft,
    faCircleChevronRight,
    faDownload,
    faTicket,
    faPrint,
    faTimeline,
    faArrowRight,
    faFile,
    faXmark,
    faRectangleAd,
    faBox,
    faList,
    faBoxesStacked,
    faShop,
    faClone,
    faClockRotateLeft,
    faFileInvoice,
    faFileLines,
    faFileImport,
    faTrash,
    faPen,
    faPencil,
    faCopy,
    faUtensils,
    faSchool,
    faToolbox,
    faChalkboardUser,
    faTruckPlane,
    faLinkSlash,
    faShuffle,
    faFileCode,
    faCalendarPlus,
    faCalendarCheck,
    faFileCirclePlus,
    faFileCode,
    faCode,
    faBan,
    faClock,
    faFloppyDisk,
    faHourglassEnd,
    faHourglassStart,
    faFilter,
    faTable,
    faSquare,
    faListCheck,
    faArrowUpRightFromSquare,
    faCashRegister,
    faToggleOn,
    faToggleOff,
    faStar,
    faTriangleExclamation,
    faMoneyCheckDollar,
    faLink,
    faHandPointer,
)
